import { callApi } from "../../api";
import { schema } from "normalizr";

const districtSchema = new schema.Entity("districts", {
}, {
  idAttribute: district => district.id,
});

export const Schemas = {
  DISTRICT: districtSchema,
  DISTRICT_ARRAY: [districtSchema],
};

export const loadDistricts = () => callApi("districts/", { method: "GET", params: {} }, Schemas.DISTRICT_ARRAY);

export const createDistrict = (clinic, useSchema = true) => callApi("districts/", {
  method: "POST",
  type: "JSON",
  body: clinic,
}, useSchema ? Schemas.DISTRICT : undefined);

export const loadDistrict = (districtId, filters) => {
  const queryParams = filters ? Object.keys(filters).reduce((res, item) => res += filters[item] !== null || filters[item] !== undefined ? `${item}=${filters[item]}&` : "", "?").slice(0, -1) : "";
  return callApi(`districts/${districtId}/${queryParams}`, { method: "GET" });
};

export const editDistrict = (districtId, clinic) => callApi(`districts/${districtId}/`, { method: "PATCH", type: "JSON", body: clinic });

export const deleteDistrict = (district, useSchema = true) => callApi("districts/", {
  method: "delete",
  type: "JSON",
  body: { id: district },
}, useSchema ? Schemas.DISTRICT : undefined);

export const deleteClinic = (districtId) => callApi(`clinics/${districtId}/`, { method: "DELETE" });

